export default __webpack_public_path__ + "static/media/alert.716845d6.svg";